const REACHABILITY_TIMEOUT_MS = 3_000;

/**
 * Sonde réservée au rechargement : l'événement `online` et le sondage `no-cors` du SDK
 * réussissent dès que le lien est up, jusqu'à 27 s avant qu'une requête aboutisse.
 *
 * Sur Tauri le document n'est pas servi par le réseau, la sonde y répond toujours vrai :
 * ce n'est pas un indicateur général de connectivité.
 */
export const isOriginReachable = async (): Promise<boolean> => {
    const controller = new AbortController();
    const timeoutId = setTimeout(
        () => controller.abort(),
        REACHABILITY_TIMEOUT_MS,
    );

    try {
        const response = await fetch(window.location.href, {
            method: "HEAD",
            cache: "no-store",
            signal: controller.signal,
        });

        // Azure Static Web Apps répond 503 dans les secondes qui suivent une reconnexion ;
        // un 4xx prouve au contraire qu'un serveur a répondu.
        return response.status < 500;
    } catch {
        return false;
    } finally {
        clearTimeout(timeoutId);
    }
};
